module.exports = __webpack_public_path__ + "static/media/menu-sketch.09d662d1.svg";